import { Controller } from "@hotwired/stimulus";

export default class extends Controller {
  static targets = ["input"];

  generate() {
    const adjectives = [
      "agile",
      "efficient",
      "scalable",
      "responsive",
      "intuitive",
      "innovative",
      "reliable",
      "modular",
      "maintainable",
      "extensible",
      "robust",
      "refactored",
      "performant",
      "streamlined",
      "optimized",
      "synchronized",
      "asynchronous",
      "concurrent",
      "cross-platform",
      "adaptive",
      "interoperable",
      "progressive",
      "accessible",
      "declarative",
      "encapsulated",
      "conversational",
      "test-driven",
      "stateful",
      "stateless",
      "event-driven",
      "orchestrated",
      "automated",
      "imperative",
      "functional",
      "high-level",
      "low-level",
      "abstract",
      "polymorphic",
      "inheritable",
      "composable",
      "idempotent",
      "empowered",
      "isomorphic",
      "object-oriented",
      "procedural",
      "declarative",
      "RESTful",
    ];

    const nouns = [
      "aardvark",
      "baboon",
      "buffalo",
      "caracal",
      "cheetah",
      "dik-dik",
      "eland",
      "elephant",
      "fennecfox",
      "gazelle",
      "giraffe",
      "hartebeest",
      "hippopotamus",
      "honeybadger",
      "honeybee",
      "hyena",
      "impala",
      "jackal",
      "kudu",
      "lemur",
      "leopard",
      "lion",
      "meerkat",
      "mongoose",
      "nyala",
      "oryx",
      "ostrich",
      "pangolin",
      "porcupine",
      "rhinoceros",
      "serval",
      "springbok",
      "squirrel",
      "tortoise",
      "vulture",
      "wildebeest",
      "warthog",
      "waterbuck",
      "zebra",
      "wilddog",
      "bushbaby",
      "civet",
      "crocodile",
      "dungbeetle",
      "galago",
      "genet",
      "gerenuk",
      "guenon",
      "monitorlizard",
      "okapi",
      "quokka",
    ];

    const adjective =
      adjectives[Math.floor(Math.random() * adjectives.length)].toLowerCase();
    const noun = nouns[Math.floor(Math.random() * nouns.length)].toLowerCase();
    const name = `${adjective}-${noun}`;

    this.inputTarget.value = name;
  }
}
